var _polygon, _path, _path2, _path3, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "223.7px",
    height: "42.7px",
    viewBox: "0 0 223.7 42.7",
    enableBackground: "new 0 0 223.7 42.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4D4D",
    points: "19.607,25.483 40.437,25.483 40.437,17.215 19.607,17.215 19.607,11.676 41.344,11.676  41.344,1.309 7.35,1.309 7.35,41.497 41.421,41.497 41.421,31.129 19.603,31.129 19.607,25.483 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M156.454,0.084c-14.497,0-23.751,8.401-23.751,21.264c0,12.867,9.254,21.268,23.751,21.268 c14.546,0,23.8-8.4,23.8-21.266C180.251,8.485,171,0.084,156.454,0.084z M156.476,31.581v-0.002c-6.849,0-10.31-4.578-10.31-10.23 c0-5.648,3.283-10.229,10.31-10.229c7.028,0,10.312,4.581,10.312,10.231S163.327,31.581,156.476,31.581z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M74.833,1.255H59.399h-0.001L44.239,41.444h12.802l2.057-5.824h16.034l2.057,5.824h12.8L74.833,1.255z  M62.27,26.635l4.845-13.716l4.844,13.716H62.27z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M112.545,16.94c-6.469-1.086-9.176-1.953-9.176-4.506c0-2.374,2.504-3.792,6.699-3.792 c5.349,0,9.102,2.267,9.102,7.605l10.403-3.761l0.068-0.024l-0.139-0.667C128.018,4.629,120.39,0,110.069,0 C99.1,0,91.137,5.476,91.137,13.021c0,9.816,9.758,11.422,17.601,12.715c6.344,1.041,9.184,1.881,9.184,4.369 c0,2.438-2.903,3.951-7.271,3.951c-5.995,0-10.12-2.912-9.787-8.402l-10.944,4.139l-0.066,0.027l0.14,0.66 C91.591,38.02,99.508,42.7,110.655,42.7c11.635,0,19.45-5.168,19.45-12.861C130.101,19.886,120.366,18.251,112.545,16.94 L112.545,16.94z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "216.585,31.129 197.54,31.129 197.54,1.284 185.246,1.284 185.246,41.469 216.585,41.442 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasol);
export default __webpack_public_path__ + "static/media/easol.a22e9443c0fb5605c8ed75daf5fb6549.svg";
export { ForwardRef as ReactComponent };